import { useFormContext } from 'react-hook-form';

import { DynamicFormControl } from '@/components/DynamicFormControl';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import DynamicFormField from '../../DynamicFormField';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { shouldShowExistingCertificateFields } from '../authenticationVisibility.utils';

/**
 * Existing certificate fields component.
 * Renders dynamic form fields for uploading an existing certificate.
 * Allows users to provide their own certificate files.
 */
const ExistingCertificateFields = () => {
  const { formState } = useFormContext();
  const { errors } = formState;

  const {
    mode,
    connectionInputSchema,
    selectedSourceTypeId,
    authenticationMode,
    newCertificate,
    regenerateCertificate,
    isResettingSourceType
  } = useCloudSourceForm();

  if (isResettingSourceType) return null;

  if (
    !shouldShowExistingCertificateFields(
      mode,
      authenticationMode,
      newCertificate,
      regenerateCertificate,
      connectionInputSchema
    )
  ) {
    return null;
  }

  return (
    <>
      {connectionInputSchema?.existing_certificate_inputs?.map((d) => (
        <DynamicFormField
          formField={d}
          key={`${selectedSourceTypeId}-${d.name}`}
          xs={12}
          sm={6}
          md={4}
        >
          <DynamicFormControl {...d} />
          {errors[d.name] && <ErrorMessage message={errors[d.name]?.message} />}
        </DynamicFormField>
      ))}
    </>
  );
};

export default ExistingCertificateFields;
